import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { startLoading, doneLoading } from '../../../../utils/loading'
import { getSchemaSidebar } from '../../../../redux/actions/sidebar'
import { updateForm9, saveForm9, getForm9Attachments } from '../../../../redux/actions/background'
import ButtonPanel from '../../../ButtonPanel'
import WhisperMoreContent from '../../../WhisperMoreContent'
import WarningMessage from '../../../../components/message/WarningMessage/WarningMessage'
import BackgroundForm9Form from './BackgroundForm9Form'
import BackgroundForm9View from './BackgroundForm9View'
import { cloneDeep } from 'lodash-es'

export default function BackgroundForm9Widget(props) {
  const { showCommandButton, schema, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [formSchema, setFormSchema] = useState(schema)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [moreContent, setMoreContent] = useState(true)
  const [moreContentBottom, setMoreContentBottom] = useState(true)

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      if (request.id) {
        response = await updateForm9(projectId, request)
      } else {
        response = await saveForm9(projectId, request)
      }
      console.log('response', response)
      if (response) {
        onChangeIsEdit(false)
        setFormSchema(response)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error: ', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const oncancel = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      const response = await getForm9Attachments(projectId)
      if (response) {
        let schema = cloneDeep(formSchema)
        schema.attachment.values = response
        setFormSchema(schema)
      }
    } catch (e) {}
    setIsError(false)
    onChangeIsEdit(!isEdit)
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      backgroundDescription: data.backgroundDescription || '',
      generalAreaInformation: data.generalAreaInformation || '',
      rootCauseAnalys: data.rootCauseAnalys || '',
      problemSolve: data.problemSolve || '',
      problemLevel: [data.problemLevel || 0],
      problemLevelOther: data.problemLevelOther || '',
      problemSolution: [data.problemSolution || 0],
      problemSolutionOther: data.problemSolutionOther || '',
    }

    // console.log('request= ', JSON.stringify(request))
    handleCallService(request)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

      {moreContent && (
        <>
          <div dangerouslySetInnerHTML={{ __html: formSchema.introduction }} />
        </>
      )}

      {formSchema.introduction && (
        <div style={{ textAlign: 'center', marginTop: '10px' }}>
          <WhisperMoreContent
            isShow={moreContent}
            onClick={() => {
              setMoreContent(!moreContent)
            }}
          />
        </div>
      )}

      {isEdit && showCommandButton ? (
        <BackgroundForm9Form
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          getValues={getValues}
        />
      ) : (
        <BackgroundForm9View schema={formSchema} />
      )}

      {formSchema?.footer && (
        <div style={{ textAlign: 'center' }}>
          <WhisperMoreContent
            isShow={moreContentBottom}
            onClick={() => {
              setMoreContentBottom(!moreContentBottom)
            }}
          />
        </div>
      )}

      {moreContentBottom && (
        <div
          dangerouslySetInnerHTML={{
            __html: formSchema?.footer,
          }}
        />
      )}

      {showCommandButton && (
        <>
          <hr />
          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText || 'ความเป็นมาหลักการและเหตุผล'}
            onSave={handleSubmit(onSubmit)}
            onCancel={oncancel}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </>
      )}
    </Panel>
  )
}
